import { createSlice } from '@reduxjs/toolkit';

import { restoreActiv8Content, searchActiv8Projects, searchDeletedActiv8Content } from './activ8SettingsActions';

const initialState = {
  projects: [],
  isProjectsLoading: false,

  selectedProjectId: null,

  content: [],
  isLoading: false,

  tableSettings: {
    page: 0,
    size: 20,
    sort: '-createdOn',
    totalElements: 0,
  },
};

const activ8Settings = createSlice({
  name: 'activ8Settings',
  initialState,
  reducers: {
    setSelectedProjectId: (state, action) => {
      state.selectedProjectId = action.payload;
      state.tableSettings.page = 0;
      state.content = [];
      state.tableSettings.totalElements = 0;
    },

    changeTableSettings: (state, action) => {
      state.tableSettings = { ...state.tableSettings, ...action.payload };
    },

    resetActiv8SettingsData: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(searchActiv8Projects.pending, (state) => {
        state.isProjectsLoading = true;
      })
      .addCase(searchActiv8Projects.fulfilled, (state, action) => {
        state.projects = action.payload;
        state.isProjectsLoading = false;
      })
      .addCase(searchActiv8Projects.rejected, (state) => {
        state.isProjectsLoading = false;
      })

      .addCase(searchDeletedActiv8Content.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(searchDeletedActiv8Content.fulfilled, (state, action) => {
        state.content = (action.payload.content ?? []).map((item) => ({
          bucketId: item.id,
          media: [item],
        }));
        state.tableSettings.totalElements = action.payload.totalElements;
        state.isLoading = false;
      })
      .addCase(searchDeletedActiv8Content.rejected, (state) => {
        state.isLoading = false;
        state.content = [];
        state.tableSettings.totalElements = 0;
      })

      .addCase(restoreActiv8Content.fulfilled, (state, action) => {
        if (action.payload.shouldGoToPreviousPage) {
          state.tableSettings.page = Math.max(0, state.tableSettings.page - 1);
        }
      });
  },
});

export const { setSelectedProjectId, changeTableSettings, resetActiv8SettingsData } = activ8Settings.actions;

export default activ8Settings.reducer;
